<template>
    <div id="calculadora">
        <v-app>
            <v-content>
                <v-container>
                    <v-layout row>
                        <v-flex xs12 md3>
                            <v-btn color="#0083CA" class="white--text" @click="newProject()">NOVO PROJETO</v-btn>
                        </v-flex>
                        <v-flex xs12 md3>
                            <v-btn color="#0083CA" class="white--text" @click="dashBoard()">VISÃO GERAL</v-btn>
                        </v-flex>
                        <v-flex xs12 md3 offset-md9>
                            <form @submit="filter">
                                <v-text-field :value="search"
                                              @input="onSearch"
                                              append-icon="search"
                                              label="Buscar"
                                              single-line
                                              hide-details></v-text-field>
                            </form>
                        </v-flex>
                    </v-layout>
                    <div id="table-header-center">
                        <v-layout row mt-5>
                            <v-flex xs12>
                                <v-data-table :headers="headers"
                                              :items="projects"
                                              :loading="loading"
                                              hide-actions
                                              class="elevation-0">
                                    <template v-slot:items="props">
                                        <td style="text-align:left">{{ props.item.Projeto }}</td>
                                        <td style="text-align:left">{{ props.item.Cliente }}</td>
                                        <td style="text-align:right">{{ props.item.Potencia | potencialize }}</td>
                                        <td style="text-align:right">
                                            {{props.item.Valor | currency('R$', 2, { thousandsSeparator: '.', decimalSeparator: ',', spaceBetweenAmountAndSymbol: true })}}
                                        </td>
                                        <td style="text-align:left">{{etapas.find( item => item.Id === props.item.Etapa).name}}</td>
                                        <td style="text-align:center">{{props.item.DataCriado}}</td>
                                        <td style="text-align:center">
                                            <!--:style="{ color: props.item.Vencido ? 'red' : '' }">-->
                                            {{props.item.DataValidade}}
                                        </td>
                                        <td class="justify-center layout px-0">
                                            <v-icon color="#021746" x-small class="mr-2" @click="personalizeProduct(props.item.Projeto, props.item.Produto)">palette</v-icon>
                                            <v-icon color="#021746" x-small class="mr-2" @click="editItem(props.item.Projeto)">edit</v-icon>
                                            <v-icon color="#0083CA" x-small class="mr-2" @click="downloadItem(props.item)">save_alt</v-icon>
                                            <!--<v-icon color="#0083CA" x-small class="mr-2" @click="downloadItemSendMail(props.item)" :disabled="loadingPDF">mail</v-icon>-->
                                            <v-icon color="#E85353" x-small class="mr-2" @click="deleteItem(props.item.Projeto)">
                                                delete_outline
                                            </v-icon>
                                        </td>
                                    </template>
                                    <template v-slot:no-data>
                                        <v-layout text-center>
                                            <v-flex>Não há projetos disponíveis</v-flex>
                                        </v-layout>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </div>
                    <v-layout justify-center row mt-3>
                        <v-pagination v-model="pagination.page" :length="pages" color="#50BED3"></v-pagination>
                    </v-layout>
                    <v-layout align-center justify-center>
                        <v-dialog v-model="dialog" persistent max-width="500px">
                            <v-card>
                                <v-card-title>
                                    <v-flex xs12>
                                        <h3 class="primary-color text-center">EXCLUIR PROJETO</h3>
                                    </v-flex>
                                </v-card-title>
                                <v-card-text>
                                    <v-flex xs12>
                                        <p class="text-center grey--text text--darken-1">
                                            Você tem certeza que deseja excluir o projeto <b class="grey--text text--darken-2">#{{selectedProject}}</b>?
                                            Você não poderá visualizar as informações do projeto após a exclusão.
                                        </p>
                                    </v-flex>
                                    <v-flex class="text-center" xs12>
                                        <v-btn outline color="#E85353" text
                                               @click="confirmDelete()">
                                            EXCLUIR
                                        </v-btn>
                                        <v-btn color="#0083CA" class="white--text" text @click="dialog = false">CANCELAR</v-btn>
                                    </v-flex>
                                    <br />
                                </v-card-text>
                            </v-card>
                        </v-dialog>
                    </v-layout>
                </v-container>
            </v-content>
        </v-app>
    </div>
</template>

<script>
    import Vue2Filters from 'vue2-filters'
    import { mapActions, mapGetters } from 'vuex'
    import axios from "axios";
    import Vue from "vue";

    export default {
        name: 'Projects',
        computed: {
            ...mapGetters(['loading', 'pages', 'pagination', 'projects', 'search', 'projeto'])
        },
        filters: {
            potencialize: value => {
                if (!value) return ''
                return `${value} KwP`
            }
        },
        methods: {
            ...mapActions(['fetchProjects', 'filter', 'reset', 'loadProject', 'calculateProject', 'setComponents', 'resetState', 'setGeneratorImage', 'setpotenciaGerador']),
            onSearch(e) {
                if (e === '') {
                    this.reset()
                }
            },
            deleteItem(id) {
                this.dialog = true;
                this.selectedProject = id;
            },
            confirmDelete() {
                axios.get(`${Vue.prototype.$apiUrl}Projeto.svc/projeto/${this.selectedProject}/delete`, { withCredentials: true })
                    .then(response => {
                        // console.log(response)
                        this.fetchProjects();
                        this.dialog = false;
                    }).catch(error => {
                        // console.log(error)
                    })
            },
            async downloadItem(item) {
                window.open("/calculadora-solar-projetos/gerar-proposta?proj=" + item.Projeto, "")
            },
            async downloadItemSendMail(item) {
                try {
                    this.loadingPDF = true;
                    const { Projeto } = item;
                    await this.loadProject(Projeto);
                    await this.calculateProject();
                    await this.setComponents(this.projeto.produto);
                    await this.setGeneratorImage(this.projeto.produto);
                    await this.setpotenciaGerador(this.projeto.produto);
                    this.$refs.templatePdfProjectRef.createPDFSendMail(this.projeto.codigo);
                    this.loadingPDF = false;
                    window.open("/calculadora-solar-projetos/gerar-proposta?email=true&proj=" + item.Projeto, "")
                } catch (e) {
                    console.error(e);
                    this.loadingPDF = true;
                }

            },
            editItem(id) {
                this.resetState()
                this.$router.push(`/calculadora-aldo-solar/editar/${id}`)
            },
            personalizeProduct(project, product) {
                this.resetState()
                this.$router.push(`/loja/personalizacao-gerador?prod=${product}&proj=${project}`)
            },
            newProject() {
                this.resetState()
                this.$router.push(`/calculadora-aldo-solar/novo`)
            },
            dashBoard() {
                this.resetState()
                this.$router.push(`/calculadora-aldo-solar/gestao/dashboard`)
            },
        },
        mixins: [Vue2Filters.mixin],
        watch: {
            pagination: {
                handler() {
                    this.fetchProjects()
                },
                deep: true
            }
        },
        mounted() {
            $.ajax({
                url: this.$apiUrl + "Session.svc/getsessions",
                dataType: "json",
                type: "GET",
                xhrFields: { withCredentials: true },
                error: () => {
                    swal({
                        title: "É necessário estar logado",
                        icon: "warning"
                    }).then(() => location.href = '/login?redirectTo=' + location.href)
                }
            });
        },
        created() {
            this.fetchProjects()
        },
        data() {
            return {
                loadingPDF: false,
                headers: [
                    {
                        text: 'Projeto',
                        value: 'Projeto',
                        align: 'left'
                    },
                    {
                        text: 'Cliente',
                        value: 'Cliente',
                        align: 'left'
                    },
                    {
                        text: 'Potência',
                        value: 'Potencia',
                        align: 'right'
                    },
                    {
                        text: 'Valor',
                        value: 'Valor',
                        align: 'right'
                    },
                    {
                        text: 'Etapa',
                        value: 'Etapa',
                        align: 'left'
                    },
                    {
                        text: 'Data Criado',
                        value: 'DataCriado',
                        align: 'center'
                    },
                    {
                        text: 'Data Vencimento',
                        value: 'DataValidade',
                        align: 'center'
                    },
                    {
                        text: 'Ações',
                        align: 'left',
                        sortable: false
                    }
                ],
                dialog: false,
                selectedProject: 0,
                etapas: [{ Id: 1, name: 'Em Negociação' }, { Id: 2, name: 'Aguardando Concessionária' }, { Id: 3, name: 'Pedidos Efetivados' }, { Id: 0, name: 'Projetos Concluído' }],
                print: false
            }
        }
    }
</script>

<style>

    div#table-header-center .theme--light.v-table {
        background-color: unset;
    }

    div#table-header-center table.v-table tbody tr {
        background-color: #F5F5F5;
        border-bottom: 2px solid white !important;
        border-collapse: separate !important;
        border-spacing: 0 15px !important;
    }

    div#table-header-center .text-xs-left {
        text-align: center !important;
    }

    .theme--light.v-table thead th {
        color: #021746 !important;
        text-align: center !important;
    }

    .theme--light.v-table thead tr:first-child {
        border-bottom: unset !important;
    }
</style>
